import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
  Link,
  IconButton,
  Flex,
  Checkbox,
} from '@chakra-ui/react';
import { useState } from 'react';
import axios from 'axios';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import baseURL from '../config/baseURL';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Prebuilt styles
import GoogleLoginButton from '../components/GoogleLoginButton';
import Footer from '../components/layout/footer';

export default function SignUpPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [secondName, setSecondName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let endpoint = baseURL + '/auth/users/';
    let userData = {
      username: email,
      email: email,
      first_name: firstName,
      last_name: secondName,
      phone: phone,
      password: password,
    };

    let options = {
      headers: { Accept: 'application/json' },
      validateStatus: (status: number) => status >= 200 && status < 300,
    };

    try {
      const response = await axios.post(endpoint, userData, options);
      console.log('response.data from sign up', response.data);
      await new Promise((resolve) => setTimeout(resolve, 1500));
      alert('Account created successfully. Proceed to sign into your account.');
      window.location.href = '/sign-in';
    } catch (error: any) {
      if (error.response) {
        // Capture and display detailed validation errors
        const errorDetails = error.response.data;
        let errorMessage = 'An error occurred.';

        if (errorDetails.username) {
          errorMessage = errorDetails.username.join(' ');
        } else if (errorDetails.email) {
          errorMessage = errorDetails.email.join(' ');
        } else if (errorDetails.password) {
          errorMessage = errorDetails.password.join(' ');
        } else {
          errorMessage = error.response.data.detail || 'Invalid input.';
        }
        setError(errorMessage);
        console.error('Error details:', errorDetails);
        console.error('Error Message:', errorMessage);
      } else if (error.request) {
        setError('Network error: Unable to reach the server.');
      } else {
        setError('Unexpected error occurred. Please try again.');
      }
      console.error('Error details:', error);
    }
  };

  return (
    <Flex
      mt={5}
      justify="center"
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
    >
      <Box
        rounded="lg"
        bg={useColorModeValue('white', 'gray.700')}
        // boxShadow="lg"
        p={8}
        maxW="md"
        w="full"
      >
        <Stack spacing={4}>
          <Heading fontSize="2xl" textAlign="center" color="#009800ff">
            Create your account
          </Heading>
          <Text fontSize="sm" textAlign="center" color="gray.500">
            Manage your customers efficiently in one place.
          </Text>
          <Text fontSize="m" textAlign="center" color="red.500">
            {error}
          </Text>

          <form onSubmit={handleSubmit}>
            <FormControl id="firstName" isRequired>
              <FormLabel>First Name</FormLabel>
              <Input
                placeholder="John"
                value={firstName}
                onChange={(event) => {
                  setFirstName(event.target.value);
                }}
              />
            </FormControl>
            <FormControl id="secondName" isRequired>
              <FormLabel>Second Name</FormLabel>
              <Input
                placeholder="eg. Max"
                value={secondName}
                onChange={(event) => {
                  setSecondName(event.target.value);
                }}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Phone</FormLabel>
              <PhoneInput
                country={'us'} // Default country
                value={phone}
                onChange={(value: string) => {
                  // Remove spaces or formatting characters
                  setPhone(value.replace(/\s+/g, ''));
                }}
                inputStyle={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '6px',
                  border: '1px solid #E2E8F0',
                  paddingLeft: '48px',
                }}
                buttonStyle={{
                  border: 'none',
                  background: 'none',
                }}
                dropdownStyle={{
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              />
            </FormControl>
            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                placeholder="john@example.com"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </FormControl>

            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                />
                <InputRightElement h="full">
                  <IconButton
                    variant="ghost"
                    aria-label="Toggle Password Visibility"
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  />
                </InputRightElement>
              </InputGroup>
            </FormControl>
            <FormControl isRequired>
              <Checkbox colorScheme="green">
                <Text fontSize="sm" ml={2}>
                  I agree to the{' '}
                  <Link href="/termsandconditions" color="#009800ff" isExternal>
                    Terms & Conditions
                  </Link>{' '}
                  and{' '}
                  <Link href="/privacyagreement" color="#009800ff" isExternal>
                    Privacy Agreement
                  </Link>
                </Text>
              </Checkbox>
            </FormControl>

            <Stack spacing={6} pt={4}>
              <Button
                type="submit"
                loadingText="Submitting"
                size="lg"
                bg="#009800ff"
                color="white"
                _hover={{ bg: '#009800f4' }}
              >
                Sign up
              </Button>
              <GoogleLoginButton />
            </Stack>
          </form>

          <Stack pt={4}>
            <Text align="center">
              Already a user?{' '}
              <Link color="#009800ff" href="/sign-in">
                Log in
              </Link>
            </Text>
          </Stack>
        </Stack>
      </Box>
      <Footer />
    </Flex>
  );
}
